<ng-container *ngIf="attachment$ | async; let attachment">
  <!--  <ng-container *ngIf="(attachment | isPdf) || (attachment | isVideo)">-->
  <!--    <ng-container-->
  <!--      *ngTemplateOutlet="attachmentPreviewTpl; context: { $implicit: thumbnail$, attachment: attachment }"-->
  <!--    ></ng-container>-->
  <!--  </ng-container>-->

  <ng-container *ngIf="attachment | isImage; else nonImageAttachmentTpl">
    <ng-container
      *ngTemplateOutlet="
        attachmentPreviewTpl;
        context: { $implicit: (attachment.urlLink | asAsync$), attachment: attachment }
      "
    ></ng-container>
  </ng-container>

  <ng-template #nonImageAttachmentTpl>
    <loop-common-attachment style="width: 160px" [attachment]="attachment"></loop-common-attachment>
  </ng-template>
</ng-container>

<ng-template #attachmentPreviewTpl let-attachmentUrlLink$ let-attachment="attachment">
  <div
    class="chat-attachment-placeholder"
    [class.d-none!]="!isNotImageLoaded"
    [style.aspect-ratio]="attachment.width + '/' + attachment.height"
  >
    <div class="placeholder-content">
      <loop-icon name="image" width="20px"></loop-icon>
    </div>
  </div>
  <div [class.d-none]="isNotImageLoaded" class="comment-image-wrapper" (click)="onAttachmentClick($event, attachment)">
    <img
      #imageTpl
      class="comment-image"
      loopImage
      [imgObservable]="attachmentUrlLink$"
      (load)="isNotImageLoaded = false"
    />
    <div [loopContextDropdown]="imageDropdownItems" class="on-image-hover-content">
      <div class="attachment-name text-overflow">
        {{ attachment.name }}
      </div>
    </div>
  </div>
</ng-template>
